import {HostBinding, Input} from '@angular/core';

export abstract class AbstractModal {
    @Input() public description: string;
    @HostBinding('class.loaded') @Input() public loaded: boolean;
    @Input() public title: string;

    constructor() {
        this.description = 'N/A';
        this.title = 'N/A';
    }
}
